export default "__VITE_ASSET__DUXdou2q__"